import 'core-js/modules/es.array.concat';
import 'core-js/modules/es.array.filter';
import 'core-js/modules/es.array.find';
import 'core-js/modules/es.array.from';
import 'core-js/modules/es.array.includes';
import 'core-js/modules/es.array.iterator';
import 'core-js/modules/es.array.join';
import 'core-js/modules/es.array.map';
import 'core-js/modules/es.array.slice';
import 'core-js/modules/es.function.name';
import 'core-js/modules/es.object.assign';
import 'core-js/modules/es.object.entries';
import 'core-js/modules/es.object.keys';
import 'core-js/modules/es.object.to-string';
import 'core-js/modules/es.object.values';
import 'core-js/modules/es.regexp.constructor';
import 'core-js/modules/es.regexp.exec';
import 'core-js/modules/es.regexp.flags';
import 'core-js/modules/es.regexp.to-string';
import 'core-js/modules/es.set';
import 'core-js/modules/es.string.includes';
import 'core-js/modules/es.string.iterator';
import 'core-js/modules/es.string.match';
import 'core-js/modules/es.string.replace';
import 'core-js/modules/es.string.split';
import 'core-js/modules/es.string.trim';
import 'core-js/modules/web.dom-collections.for-each';
import 'core-js/modules/web.dom-collections.iterator';
import { assertType, assertRange, assert } from 'yaassertion';
import Cldr from 'cldrjs/dist/cldr';
import { isWorldReadyInstance } from '@paypalcorp/worldready-core';

function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _createForOfIteratorHelperLoose(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (t) return (t = t.call(r)).next.bind(t);
  if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
    t && (r = t);
    var o = 0;
    return function () {
      return o >= r.length ? {
        done: !0
      } : {
        done: !1,
        value: r[o++]
      };
    };
  }
  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _inheritsLoose(t, o) {
  t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}

/**
 * Utility function to remove literals that are not required.
 * We only want to add a literal if we've previously encountered a non-literal field
 * and it's value is not an empty string. Hence we don't add a literal field to the
 * response immediately as we encounter it, but we wait until we see the next non-literal
 * field before adding the literal to our response.
 * @param {Array} parts an array with details about each part. Required props for each part are:
 *  type: a string specifying whether the part is literal or not
 *  value: value for that part
 * @returns {Array} modified array where unnecessary literals are removed
 */
function removeExtraLiterals(parts) {
  if (parts === void 0) {
    parts = [];
  }
  if (!parts || !parts.length) {
    return;
  }
  var addedFirstNonLiteralField = false,
    literalField = null,
    result = [];
  parts.forEach(function (part) {
    if (part.type !== "literal") {
      if (literalField && addedFirstNonLiteralField && part.value.length) {
        result.push(literalField);
      }
      literalField = null;
      result.push(part);
      if (part.value.length) {
        addedFirstNonLiteralField = true;
      }
    } else {
      literalField = Object.assign({}, part);
    }
  });
  return result;
}

/* Gets value in object path
 * @param {object} obj
 * @param {string|array} path
 * @examples
 * get({foo: 1, bar: {baz: 2}}, 'bar.baz');
 * > 2
 * get({foo: 1, bar: {baz: 2}}, 'foo.bar.baz.quax');
 * > undefined
 * NOTE: Asterisk support for Node.js only (reduced bytes)
 */
var objectGet;
{
  // Client-side
  objectGet = function objectGet(obj, path) {
    if (typeof path === "string") {
      path = path.split(".");
    }
    if (!path.length) {
      return obj;
    }
    if (process.env.NODE_ENV !== "production") {
      if (path.some(function (part) {
        return part === "*";
      })) {
        throw new Error("Internal error: objectGet asterisk support NOT available");
      }
    }
    var prop = path.slice(-1);
    var node = path.slice(0, -1).reduce(function (node, item) {
      return node[item] || {};
    }, obj);
    return node[prop];
  };
}

/**
 * Actual PersonNameFormat implementation. The idea is the this whole file
 * becomes open source.
 */

/**
 * Given:
 * - stringLayout: "{foo} {bar}"
 * - stringLayouts:
 *   {
 *     "bar": "{a} {b.c}"
 *   }
 * Returns:
 * [
 *   {
 *     "type": "foo"
 *   },
 *   {
 *     "type": "literal",
 *     "value": " "
 *   },
 *   {
 *     "type": "bar",
 *     "parts": [
 *       {
 *         "type": "a"
 *       },
 *       {
 *         "type": "literal",
 *         "value": " "
 *       },
 *       {
 *         "type": "b.c"
 *       }
 *     ]
 *   }
 * ]
 */
// TODO: Find a better place for common functions between address and name
function stringLayoutToPartsLayout(stringLayout, stringLayouts, checkStringLayouts) {
  if (stringLayouts === void 0) {
    stringLayouts = {};
  }
  if (checkStringLayouts === void 0) {
    checkStringLayouts = true;
  }
  var partsLayout = [];
  var lastMatchPos = 0;

  // For every matching variable (e.g., "{foo}"), add two parts: the literal
  // that precedes it and the matching type variable (e.g., { type: "foo" }).
  stringLayout.replace(/{[^}]+}/g, function (match, pos) {
    partsLayout.push({
      type: "literal",
      value: stringLayout.slice(lastMatchPos, pos)
    });
    var type = match.slice(1, -1);
    var part = {
      type: type
    };
    if (checkStringLayouts && stringLayouts[type]) {
      part.parts = stringLayoutToPartsLayout(stringLayouts[type], stringLayouts, false);
    }
    partsLayout.push(part);
    lastMatchPos = pos + match.length;
  });
  partsLayout.push({
    type: "literal",
    value: stringLayout.slice(lastMatchPos)
  });

  // Remove empty literals.
  return partsLayout.filter(function (_ref) {
    var type = _ref.type,
      value = _ref.value;
    return type !== "literal" || value;
  });
}
var DEFAULT_SCRIPT_FALLBACK = "Latn";
/**
 * Returns the object script, which is:
 * - `undefined` if the string is empty,
 * - `"Latin"` if the whole string is Latin, or
 * - The regionDefaultScript if string contains any non-Latin (because it's easier to do this than to
 *   identify which script it really is AND it's assertive in our case).
 */
function getStringScript(string, regionDefaultScript) {
  if (!string.length) {
    return;
  }
  for (var _iterator = _createForOfIteratorHelperLoose(string), _step; !(_step = _iterator()).done;) {
    var ch = _step.value;
    if (ch.charCodeAt(0) > 0x24f) {
      return regionDefaultScript;
    }
  }
  return "Latn";
}

/**
 * Helper function that determines what script should be used to format the address and name.
 * Determination rules and fallbacks are as follows:
 *  1. For address region with region default script as non Latn script and if address/name object contain non Latn script characters, then use non Latn script if supported by address region.
 *  2. If address object scipt is not supported for addressRegion or we don't have the metadata for that script,
 *      then fallback to the primary_script for addressRegion identified in G11nMetadata
 *  3. if for some reason we don't have address layout metadata for the primary_script identified in G11nMetadata for primary_script,
 *      then fallback to 'Latn' as we always have address layout for Latn script
 * @param {Object} stringLayouts an object containing layouts for all the scripts for addressRegion
 * @param {Object} options object with additional properties for identifying the final script that should be used
 * @returns {Object} an object with the address layout based on script identified by above rules
 */
var getLayoutFromScript = function getLayoutFromScript(stringLayouts, options) {
  if (stringLayouts === void 0) {
    stringLayouts = {};
  }
  if (options === void 0) {
    options = {};
  }
  if (!Object.keys(stringLayouts).length || !options.primaryScript) {
    return null;
  }
  var _options = options,
    finalScript = _options.finalScript,
    primaryScript = _options.primaryScript;
  return stringLayouts[finalScript] || stringLayouts[primaryScript] || stringLayouts[DEFAULT_SCRIPT_FALLBACK];
};

/**
 * Actual PersonNameFormat implementation. The idea is the this whole file
 * becomes open source.
 */

var properties = ["namePrefix", "givenName", "middleName", "surname", "secondSurname", "nameSuffix", "altName"];

/**
 * isProperty is a hash of the form: { <property>: true }, which makes easier to
 * check if a string is one of the properties listed above.
 */
var isProperty = Object.assign.apply(Object, properties.map(function (field) {
  var _ref2;
  return _ref2 = {}, _ref2[field] = true, _ref2;
}));

/**
 * Actual formatToParts function.
 *
 * @param {String} name Person name
 * @param {Object} options.layout Metadata for the chosen style, e.g.:
 *   {
 *     "Latn": [
 *       {
 *         "type": "givenName"
 *       },
 *       {
 *         "type": "literal",
 *         "value": " "
 *       },
 *       {
 *         "type": "surname"
 *       }
 *     ]
 *   }
 * @param {String} options.regionDefaultScript Region default script
 * @param {String} options.script Locale script
 * @param {Object} options.supportedScripts Supported scripts array.
 *
 * @return {Array} Formatted person name parts.
 */
function formatToParts(name, _ref3) {
  var layouts = _ref3.layouts,
    regionDefaultScript = _ref3.regionDefaultScript,
    localeScript = _ref3.localeScript,
    supportedScripts = _ref3.supportedScripts,
    requiredFields = _ref3.requiredFields,
    formatAs = _ref3.formatAs,
    nameFormatData = _ref3.nameFormatData,
    isLayoutProperties = _ref3.isLayoutProperties,
    includeIsLayoutProperties = _ref3.includeIsLayoutProperties;
  var nameScript;

  // Optimization:
  // If the region default script is different than "Latn", check name.
  // Otherwise, not needed, it's always going to be "Latn".
  if (regionDefaultScript === "Latn") {
    nameScript = "Latn";
  } else {
    nameScript = getStringScript(Object.entries(name).filter(function (_ref4) {
      var type = _ref4[0];
      return isProperty[type];
    }).map(function (_ref5) {
      var value = _ref5[1];
      return value;
    }).join(""), regionDefaultScript);
  }

  // The nameScript has precedence. In case address is empty (and therefore nameScript is
  // undefined), use locale script if it's supported
  // by the region OR Latin.
  var finalScript = nameScript || (supportedScripts.includes(localeScript) ? localeScript || regionDefaultScript : "Latn");

  // The name script determines the layout (e.g., latin vs Japanese), but the
  // user region determines the supported scripts (e.g., on US only latin names
  // are supported, on JP both latin and Japanese are supported).
  // TODO Transform at constructor-time.
  var stringLayout = getLayoutFromScript(layouts, {
    primaryScript: regionDefaultScript,
    finalScript: finalScript
  });
  var layout = stringLayoutToPartsLayout(stringLayout);
  var parts = getPartsFromLayout(layout, {
    name: name,
    requiredFields: requiredFields
  });
  parts = removeIsLayoutProperties(parts, isLayoutProperties[finalScript] || [], includeIsLayoutProperties);

  // remove unwanted literals
  parts = removeExtraLiterals(parts);

  // apply required formatting (e.g., title case)
  parts.forEach(function (part) {
    if (part.type !== "literal") {
      if (formatAs) {
        part.value = applyFormatting(part.value, formatAs, {
          nameFormatData: nameFormatData
        });
      }
    }
  });
  return parts;
}

/**
 * This version might be used in for loops and the like when
 * it is unknown whether non-BMP characters exist before the specified index position.
 * Reference: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/charCodeAt
 * @param {string} string to get the character
 * @peram {number} the index position
 **/
function fixedCharCodeAt(str, idx) {
  // ex. fixedCharCodeAt('\uD800\uDC00', 0); // 65536
  // ex. fixedCharCodeAt('\uD800\uDC00', 1); // false
  idx = idx || 0;
  var code = str.charCodeAt(idx);
  var hi, low;

  // High surrogate (could change last hex to 0xDB7F
  // to treat high private surrogates
  // as single characters)
  if (0xd800 <= code && code <= 0xdbff) {
    hi = code;
    low = str.charCodeAt(idx + 1);
    if (isNaN(low)) {
      return hi;
    }
    return (hi - 0xd800) * 0x400 + (low - 0xdc00) + 0x10000;
  }
  if (0xdc00 <= code && code <= 0xdfff) {
    // Low surrogate
    // We return false to allow loops to skip
    // this iteration since should have already handled
    // high surrogate above in the previous iteration
    return false;
    // hi = str.charCodeAt(idx - 1);
    // low = code;
    // return ((hi - 0xD800) * 0x400) +
    //   (low - 0xDC00) + 0x10000;
  }
  return code;
}
function convertToHex(charCode) {
  var result = "";
  var hex = charCode.toString(16);
  if (hex.length > 4) {
    result += "U+" + hex;
  } else {
    result += "U+" + ("00" + hex).slice(-4);
  }
  result = result.toUpperCase();
  return result;
}
function invalidCodePointFromString(string, regex) {
  var codePoint;
  for (var i = 0, chr; i < string.length; i++) {
    if (string[i].match(regex) === null) {
      if ((chr = fixedCharCodeAt(string, i)) === false) {
        continue;
      }
      codePoint = chr;
      /* we care only on the first one */
      break;
    }
  }
  return codePoint ? convertToHex(codePoint) : undefined;
}
function getPartsFromLayout(layout, options) {
  if (options === void 0) {
    options = {};
  }
  if (!layout) {
    return undefined;
  }
  var _options2 = options,
    name = _options2.name,
    requiredFields = _options2.requiredFields;
  return layout.map(function (_ref6) {
    var type = _ref6.type,
      value = _ref6.value;
    if (type !== "literal") {
      value = name[type] || "";
    }
    return Object.assign({
      type: type,
      value: value
    }, type !== "literal" && {
      required: requiredFields.includes(type) ? true : false
    });
  });
}
/**
 * Helper function that will remove all named properties (non separators) that have isLayout set to false from the parts object
 * @param {Array} parts Array of objects that include all parts of our provided name
 * @param {Array} isLayoutProperties Array of strings that include all named properties to be removed from our parts Array
 * @param {Boolean} includeIsLayoutProperties Boolean flag that if set to true, it will render all parts regardless if they're in "isLayoutProperties"
 * @returns {Array}
 */
function removeIsLayoutProperties(parts, isLayoutProperties, includeIsLayoutProperties) {
  // Return parts as-is if includeIsLayoutProperties is set to true or there's no elements to filter from our isLayoutProperties array
  return includeIsLayoutProperties || isLayoutProperties.length === 0 ? parts : parts.filter(function (part) {
    return !isLayoutProperties.includes(part.type);
  });
}

/**
 * Helper function to apply different kind of formatting to name field.
 * Following are the types of formatters are currently applied:
 *  - titleCase
 * @param {String} nameField name field on which formatting needs to be applied
 * @param {Object} formatAs object indicating what kind of formatting should be applied
 * @param {Object} options param to pass in additional metadata needed for formatting
 * @returns {String}
 */
function applyFormatting(nameField, formatAs, options) {
  if (formatAs === void 0) {
    formatAs = {};
  }
  if (options === void 0) {
    options = {};
  }
  if (!nameField || !formatAs) {
    return nameField;
  }
  var formattedValue = nameField;
  if (formatAs.titleCase) {
    formattedValue = transformNameFieldToTitleCase(formattedValue, options);
  }
  return formattedValue;
}

/**
 * Helper function to convert name field to title case. E.g,
 * joHN --> John
 * doe --> Doe
 * @param {String} nameField Value that needs to be converted to title case
 * @returns {String}
 */
function transformNameFieldToTitleCase(nameField, options) {
  if (options === void 0) {
    options = {};
  }
  if (!nameField) {
    return nameField;
  }
  var result = nameField;
  var _options3 = options,
    _options3$nameFormatD = _options3.nameFormatData.titleCase,
    PUNCTUATIONS = _options3$nameFormatD.PUNCTUATIONS,
    ALL_LOWER_CASE = _options3$nameFormatD.ALL_LOWER_CASE,
    GAELIC_TERMS = _options3$nameFormatD.GAELIC_TERMS;
  if (!PUNCTUATIONS || !PUNCTUATIONS.pattern || !ALL_LOWER_CASE || !ALL_LOWER_CASE.pattern || !GAELIC_TERMS || !GAELIC_TERMS.pattern) {
    return nameField;
  }

  // the unicode range of characters check to find punctuations in all locales
  result = result.replace(new RegExp(PUNCTUATIONS.pattern, PUNCTUATIONS.flags), function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substring(1).toLowerCase();
  });

  // for names like Mc, Mac
  result = result.replace(new RegExp(GAELIC_TERMS.pattern, GAELIC_TERMS.flags), function ($1, $2, $3, $4, $5) {
    return $2 ? $3.toUpperCase() + $4 + $5.toUpperCase() : $1;
  });

  // for names like Picaso de Casa Seville Guiterrez
  result = result.replace(new RegExp(ALL_LOWER_CASE.pattern, ALL_LOWER_CASE.flags), function (_, match) {
    return match.toLowerCase();
  });
  return result;
}
var NAME_TYPES = {
  PERSON: "person",
  BUSINESS: "business"
};
var PERSON_TYPES = {
  LEGAL: "LEGAL",
  ALIAS: "ALIAS"
};
var NAME_STYLES = {
  FULL: "full",
  INFORMAL: "informal",
  BUSINESS_INFORMAL: "businessInformal"
};
var DEFAULT_FORMATAS = {
  titleCase: false
};
var REGISTERED_BUSINESS_TYPE_KEY_MAP = {
  "NON-REGISTERED-BUSINESS": "nonRegistered",
  "REGISTERED-BUSINESS": "registered"
};
var NAME_ERROR_CODE = {
  MISSING_REQUIRED: "MISSING_REQUIRED",
  INVALID_SCRIPT: "INVALID_SCRIPT",
  INVALID_ALL_PUNCTUATION: "INVALID_ALL_PUNCTUATION",
  INVALID_ALL_NUMBER: "INVALID_ALL_NUMBER",
  INVALID_ALL_RESTRICTED: "INVALID_ALL_RESTRICTED",
  INVALID_ALL_REGISTERED_ACCOUNT: "INVALID_ALL_REGISTERED_ACCOUNT",
  INVALID_MAX_LENGTH_EXCEEDED: "INVALID_MAX_LENGTH_EXCEEDED",
  INVALID_ALL_OFFENSIVE: "INVALID_ALL_OFFENSIVE",
  INVALID_ALL_MIXED_SCRIPT: "INVALID_ALL_MIXED_SCRIPT",
  INVALID_NATIONALITY_SCRIPT: "INVALID_NATIONALITY_SCRIPT",
  INVALID_CHARACTER_REPETITION: "INVALID_CHARACTER_REPETITION",
  INVALID_ALL_HONORIFICS: "INVALID_ALL_HONORIFICS",
  INVALID_BOUNDARY_PATTERN: "INVALID_BOUNDARY_PATTERN",
  INVALID_KEYBOARD_BANGING: "INVALID_KEYBOARD_BANGING",
  INVALID_SINGLE_CHARACTER: "INVALID_SINGLE_CHARACTER",
  INVALID_ALL_NON_VOWEL: "INVALID_ALL_NON_VOWEL",
  SPAM_DETECTED: "SPAM_DETECTED"
};
var CLDR_SUPPLEMENTAL_PERSON_NAME_DATA_PATH = "supplemental/personNameData";

/**
 * Identifies most likely script used in name.
 * If all the name's field don't match to a single script
 * then default script would be returned.
 * For example:
 * - for name object as {givenName: "John", surname: "Walter"},
 *  then function will return scripts as ["Latn"]
 * - for name object as {givenName: "John赫洛", surname: "Walter"} and country is CN,
 *  then function will return scripts as ["Latn", "Hans"].
 *  Latn and Hans are the default scripts for CN country
 *
 * @param {*} scriptValidations - script validation object
 * @param {*} name - personal name
 * @returns list of possible scripts for a given name
 */
function getNameScript(scriptValidations, name) {
  var characterRangeRegex;
  var nameConcat = properties.reduce(function (nameConcat, item) {
    return nameConcat + (name[item] || "");
  }, "");
  var scripts = [];
  Object.keys(scriptValidations).forEach(function (currentScript) {
    var currScriptValidations = scriptValidations[currentScript];
    characterRangeRegex = currScriptValidations.characterRange;
    if (characterRangeRegex) {
      characterRangeRegex = new RegExp("^(" + characterRangeRegex + ")$");
      if (isCharacterRangeMatch(characterRangeRegex, nameConcat)) {
        scripts.push(currentScript);
      }
    }
  });
  return scripts;
}
/**
 * Returns true if name field is in character range regex
 * @param {*} characterRange - character range regex
 * @param {*} name - name field
 * @returns trues if name field is in character range regex
 */
function isCharacterRangeMatch(characterRange, name) {
  var isMatch = true;
  var uniqueCharArr = new Set(name);
  for (var _iterator2 = _createForOfIteratorHelperLoose(uniqueCharArr), _step2; !(_step2 = _iterator2()).done;) {
    var uniqueChar = _step2.value;
    if (!characterRange.test(uniqueChar)) {
      isMatch = false;
      break;
    }
  }
  return isMatch;
}

/**
 * Returns list of scripts supported for a given business type
 * @param {*} businessType - business type
 * @param {*} supportedScriptsByCountry - mapping between supported scripts and country
 * @returns Returns list of scripts supported for a given business type
 */
function getBusinessNameSupportedScripts(businessType, supportedScriptsByCountry) {
  var supportedScripts = objectGet(supportedScriptsByCountry, ["business", "type"]);
  var businessTypeScripts = businessType ? supportedScripts[businessType] || supportedScripts.DEFAULT : supportedScripts.DEFAULT;
  return businessTypeScripts;
}

/**
 * Identifies most likely script used in business name.
 * @param {*} bName - business name
 * @param {*} nameValidations - name validation metadata
 * @param {*} businessType - business type
 * @returns Set of most of script used in business name.
 */
function getBusinessNameScripts(bName, nameValidations, businessType) {
  var scripts = getBusinessNameSupportedScripts(businessType, nameValidations.supportedScripts);
  var bScripts = new Set();
  var _loop = function _loop(index) {
    var characterRangeRegex = objectGet(nameValidations, ["businessScriptValidations", scripts[index], "characterRange"]);
    if (characterRangeRegex) {
      characterRangeRegex = new RegExp("^(" + characterRangeRegex + ")*?$");
      var bNameStringArr = bName.trim().split("");
      bNameStringArr.map(function (element) {
        if (characterRangeRegex.test(element)) {
          bScripts.add(scripts[index]);
          return;
        }
      });
    }
  };
  for (var index = 0; index < scripts.length; index = index + 1) {
    _loop(index);
  }
  return bScripts;
}

/**
 * Asserts name if it is a valid name or not.
 * @param {*} name
 */
function assertName(name) {
  assertType(name, "name", ["plain object"]);
  properties.forEach(function (property) {
    assertType(name[property], "name." + property, ["string", "undefined"]);
  });
}

/**
 * Assert nationality value when name is business name.
 * @param {*} nationality
 * @param {*} type
 */
function assertNationalityWithBusinessType(nationality, type) {
  if (nationality && type === "business") {
    console.log("WARNING: When type is business, options.nationality should be unabled. See our updated docs for more details.\n Fix your code by deleting options.nationality.");
  }
}

/**
 * Assert businessType when name is person name
 * @param {*} businessType
 * @param {*} type
 */
function assertBusinessTypeWithPerson(businessType, type) {
  if (businessType && type === "person") {
    console.log("WARNING: When options.businessType is declared in constructor, options.type should be business only. See our updated docs for more details.\n Fix your code by using business only for your options.type.");
  }
}

/**
 * Assert registeredBusinessType when name is person name
 * @param {*} registeredBusinessType
 * @param {*} type
 */
function assertregisteredBusinessTypeWithPerson(registeredBusinessType, type) {
  if (registeredBusinessType && type === "person") {
    console.log("WARNING: When options.registeredBusinessType is declared in constructor, options.type should be business only. See our updated docs for more details.\n Fix your code by using business only for your options.type.");
  }
}
function validateName(name, _ref7) {
  var requiredProperties = _ref7.requiredFields,
    nameValidations = _ref7.validationsMeta,
    nationality = _ref7.nationality,
    personType = _ref7.personType,
    nameRegion = _ref7.nameRegion,
    personNameValidRegEx = _ref7.personNameValidRegEx;
  var fields = properties;
  var retErrors = [];
  Object.defineProperty(retErrors, "errors", {
    get: function get() {
      if (process.env.NODE_ENV !== "production") {
        var errorMsg = "Please note that errors are no longer returned as an object, instead they are returned as an array. " + "From now on, please access the array directly rather than through the errors property. For more information, please read here: " + "https://github.paypal.com/pages/Globalization-R/worldready-js/docs/name-api.html#nameformatprototypevalidatenameobj";
        console.warn(errorMsg);
      }
      return this;
    }
  });

  // Required name level field
  var requiredFieldErrors = validateRequiredField(name, requiredProperties);
  var nonEmptyNamefields = [];
  properties.forEach(function (field) {
    if (name[field] && name[field] !== "") {
      nonEmptyNamefields.push(field);
    }
  });

  // Script level check - It consist of INVALID_SCRIPT,
  // INVALID_ALL_MIXED_SCRIPT and INVALID_NATIONALITY_SCRIPT checks

  // checking INVALID_SCRIPT
  var scriptErrors = validateScript(name, personType, nonEmptyNamefields, personNameValidRegEx);
  if (scriptErrors.length) {
    retErrors.push.apply(retErrors, scriptErrors.concat(requiredFieldErrors));
    return retErrors;
  }
  var scripts = getNameScript(nameValidations.scriptValidations, name);
  // checking INVALID_ALL_MIXED_SCRIPT
  var mixedScriptError = validateMixedScript(scripts, nonEmptyNamefields);
  if (mixedScriptError.length) {
    retErrors.push.apply(retErrors, mixedScriptError.concat(requiredFieldErrors));
    return retErrors;
  }
  // checking INVALID_NATIONALITY_SCRIPT
  var nationalityError = validateNationalityScript(scripts, nationality, nameValidations.supportedScripts, nonEmptyNamefields, personType, nameRegion);
  if (nationalityError.length) {
    retErrors.push.apply(retErrors, nationalityError.concat(requiredFieldErrors));
    return retErrors;
  }

  // element level check
  var errors = fields.reduce(function (errors, field) {
    return errors.concat(validateField(name, field, nameValidations, scripts));
  }, []);
  retErrors.push.apply(retErrors, errors.concat(requiredFieldErrors));
  return retErrors;
}
function validateBusinessName(businessName, _ref8) {
  var nameValidations = _ref8.validationsMeta,
    businessType = _ref8.businessType,
    registeredBusinessType = _ref8.registeredBusinessType;
  var errors = [];
  if (!businessName || !businessName.businessName) {
    errors.push({
      code: NAME_ERROR_CODE.MISSING_REQUIRED,
      element: "businessName"
    });
    return errors;
  }
  var businessNameValidations = nameValidations.businessScriptValidations;
  var bName = businessName.businessName;
  var businessNameKey = getBusinessKey(businessType);
  var registeredBusinessTypeKey = getregisteredBusinessTypeKey(registeredBusinessType);
  var characterRangeRegex = getBusinessNameCharacterRangeForScripts(nameValidations, getBusinessNameSupportedScripts(businessType, nameValidations.supportedScripts));
  // Script Character Range Validation
  if (characterRangeRegex) {
    characterRangeRegex = new RegExp("^(" + characterRangeRegex + ")*?$");
    if (!characterRangeRegex.test(bName)) {
      var codePoint = invalidCodePointFromString(bName, characterRangeRegex);
      if (codePoint !== undefined) {
        errors.push({
          code: NAME_ERROR_CODE.INVALID_SCRIPT,
          element: "businessName",
          invalidCodePoint: codePoint
        });
      }
      return errors;
    }
  }
  var errorMap = {};
  var scriptsSet = getBusinessNameScripts(bName, nameValidations, businessType);
  var scripts = Array.from(scriptsSet);
  for (var index = 0; index < scripts.length; index = index + 1) {
    var scriptBasedRegexes = businessNameValidations[scripts[index]];
    // INVALID_ALL_PUNCTUATION
    errorMap = getPunctuationNameError(objectGet(scriptBasedRegexes, ["punctuation", "pattern", businessNameKey]), bName, "businessName", errorMap);
    // INVALID_ALL_OFFENSIVE
    errorMap = getOffensiveNameError(objectGet(scriptBasedRegexes, ["offensive", "pattern", businessNameKey]), bName, "businessName", errorMap);
    // INVALID_ALL_NUMBER
    var numberRegex = objectGet(scriptBasedRegexes, ["numberRange", "pattern", businessNameKey]);
    if (numberRegex) {
      numberRegex = new RegExp("^(" + numberRegex + ")*?$", "i");
      if (numberRegex.test(bName)) {
        errorMap.INVALID_ALL_PUNCTUATION = {
          code: NAME_ERROR_CODE.INVALID_ALL_PUNCTUATION,
          element: "businessName"
        };
      }
    }
    // INVALID_ALL_RESTRICTED
    var restrictedNameRegex = objectGet(scriptBasedRegexes, ["restrictedBusinessNameRange", "pattern", businessNameKey]);
    if (restrictedNameRegex) {
      restrictedNameRegex = new RegExp("^(" + restrictedNameRegex + ")$", "i");
      if (restrictedNameRegex.test(bName)) {
        errorMap.INVALID_ALL_RESTRICTED = {
          code: NAME_ERROR_CODE.INVALID_ALL_RESTRICTED,
          element: "businessName"
        };
      }
    }
    // INVALID_ALL_REGISTERED_ACCOUNT
    var registeredNameValidation = objectGet(scriptBasedRegexes, ["registeredBusinessNameRange", "pattern", registeredBusinessTypeKey]);
    if (registeredNameValidation) {
      registeredNameValidation = new RegExp(registeredNameValidation, "i");
      if (registeredNameValidation.test(bName)) {
        errorMap.INVALID_ALL_REGISTERED_ACCOUNT = {
          code: NAME_ERROR_CODE.INVALID_ALL_REGISTERED_ACCOUNT,
          element: "businessName"
        };
      }
    }
  }
  Object.keys(errorMap).forEach(function (key) {
    errors.push(errorMap[key]);
  });
  return errors;
}
function getregisteredBusinessTypeKey(registeredBusinessType) {
  return registeredBusinessType && REGISTERED_BUSINESS_TYPE_KEY_MAP[registeredBusinessType] ? REGISTERED_BUSINESS_TYPE_KEY_MAP[registeredBusinessType] : REGISTERED_BUSINESS_TYPE_KEY_MAP["REGISTERED-BUSINESS"];
}
function getBusinessKey(businessType) {
  if (businessType === "LEGAL") {
    return "legal";
  }
  if (businessType === "DOING_BUSINESS_AS") {
    return "doingBusinessAs";
  }
  return "default";
}
function getBusinessNameCharacterRangeForScripts(nameValidations, scripts) {
  var consolidatedCharacterRange = null;
  for (var index = 0; index < scripts.length; index = index + 1) {
    var characterRange = objectGet(nameValidations, ["businessScriptValidations", scripts[index], "characterRange"]);
    consolidatedCharacterRange = consolidatedCharacterRange ? consolidatedCharacterRange + "|" + characterRange : characterRange;
  }
  return consolidatedCharacterRange;
}
function validateField(name, nameField, nameValidations, scripts) {
  // errorMap is of following structure:
  // {
  //  code : { error obj}
  // }
  // values of errorMap object will be return if name is not in validList
  var errorMap = {};
  var isNameInValidListFlag = false;
  if (name[nameField]) {
    // Currently, punctuation and keyboard banging are same in all the
    // scripts and that is why we can take any script to fetch regex.
    // Once we have script specific regex then we need to execute punctuation
    // and keyboard banging over all the scripts.
    scripts.forEach(function (script) {
      var scriptBasedRegexes = nameValidations.scriptValidations[script];
      var nameMaxLength = null;
      if (nameValidations.maxLength && nameValidations.maxLength[script] && nameValidations.maxLength[script][nameField]) {
        nameMaxLength = nameValidations.maxLength[script][nameField];
      }
      var repetition = nameValidations.repetition,
        honorificsVariation = nameValidations.honorificsVariation,
        singleCharacterValidation = nameValidations.singleCharacterValidation,
        boundaryValidation = nameValidations.boundaryValidation;
      if (isNameInValidList(name, nameField, scriptBasedRegexes)) {
        isNameInValidListFlag = true;
        return;
      }
      // Run all the validations on the name[nameField]
      validatePunctuation(name, nameField, scriptBasedRegexes, errorMap);
      validateRepetition(name, nameField, repetition, errorMap);
      validateHonorifics(name, nameField, honorificsVariation, errorMap);
      validateBoundaryValidation(name, nameField, boundaryValidation, errorMap);
      validateKeyboardBanging(name, nameField, scriptBasedRegexes, errorMap);
      validateSingleCharacter(name, nameField, singleCharacterValidation, errorMap);
      validateNonVowel(name, nameField, scriptBasedRegexes, nameValidations, errorMap);
      validateOffensiveName(name, nameField, scriptBasedRegexes, errorMap);
      validateMaxLength(name, nameField, nameMaxLength, errorMap);
    });
  }
  return isNameInValidListFlag ? [] : Object.values(errorMap);
}

/**
 * check each field whether length of name segment is exceeded maximum length value.
 *
 * @param {Obj} name
 * @param {String} nameField
 * @param {Number} nameMaxLength
 * @param {Obj} errorMap
 * @return {Obj} errorMap
 */
function validateMaxLength(name, nameField, nameMaxLength, errorMap) {
  if (!name[nameField] || !nameMaxLength) {
    return errorMap;
  }
  if (name[nameField].length > nameMaxLength) {
    errorMap.INVALID_MAX_LENGTH_EXCEEDED = {
      code: NAME_ERROR_CODE.INVALID_MAX_LENGTH_EXCEEDED,
      element: nameField
    };
  }
  return errorMap;
}
function validateOffensiveName(name, nameField, scriptBasedRegexes, errorMap) {
  if (!Object.keys(scriptBasedRegexes.offensive.pattern).includes(nameField) || !name[nameField]) {
    return errorMap;
  }
  return getOffensiveNameError(scriptBasedRegexes.offensive.pattern[nameField], name[nameField], nameField, errorMap);
}
function getOffensiveNameError(offensiveNameRegex, value, element, errorMap) {
  if (offensiveNameRegex) {
    offensiveNameRegex = new RegExp(".*?" + offensiveNameRegex + ".*?", "i");
    if (offensiveNameRegex.test(value)) {
      errorMap.INVALID_ALL_OFFENSIVE = {
        code: NAME_ERROR_CODE.INVALID_ALL_OFFENSIVE,
        element: element
      };
    }
  }
  return errorMap;
}
function isNameInValidList(name, nameField, scriptBasedRegexes) {
  if (!Object.keys(scriptBasedRegexes.validList.pattern).includes(nameField) || !name[nameField]) {
    return false;
  }
  var validListRegex = scriptBasedRegexes.validList.pattern[nameField];
  if (validListRegex) {
    validListRegex = new RegExp("^(" + validListRegex + ")$", "i");
    if (validListRegex.test(name[nameField].toLowerCase())) {
      return true;
    }
  }
  return false;
}
function isInitialName(name, nameField, scriptBasedRegexes) {
  if (!Object.keys(scriptBasedRegexes.initialsRange.pattern).includes(nameField) || !name[nameField]) {
    return false;
  }
  var initialsRangeRegex = scriptBasedRegexes.initialsRange.pattern[nameField];
  if (initialsRangeRegex) {
    initialsRangeRegex = new RegExp("^(" + initialsRangeRegex + ")$", "i");
    if (initialsRangeRegex.test(name[nameField])) {
      return true;
    }
  }
  return false;
}
function validateRequiredField(name, requiredProperties) {
  var errors = [];
  requiredProperties.forEach(function (requiredField) {
    if (!name[requiredField] || name[requiredField] === "") {
      errors.push({
        code: NAME_ERROR_CODE.MISSING_REQUIRED,
        element: requiredField
      });
    }
  });
  return errors;
}
function validateMixedScript(scripts, nonEmptyNamefields) {
  var errors = [];
  if (scripts.length === 0) {
    nonEmptyNamefields.forEach(function (field) {
      errors.push({
        code: NAME_ERROR_CODE.INVALID_ALL_MIXED_SCRIPT,
        element: field
      });
    });
  }
  return errors;
}

/**
 *
 * @param {*} supportedScripts metadata object include business and personal's supported scripts
 * @param {*} personType personType from nameFormat
 * @param {*} nationality nationality from nameFormat
 * @param {*} nameRegion nameRegion from nameFormat
 * @returns an Array includes supportedScripts for specific nationality
 */
function getNationalityScripts(supportedScripts, personType, nationality, nameRegion) {
  var _supportedScriptsByNa6, _supportedScriptsByNa7, _supportedScriptsByNa8, _supportedScriptsByNa9, _supportedScriptsByNa0, _supportedScriptsByNa1;
  var supportedScriptsByNationality = supportedScripts.personal;
  if (!nationality) {
    var _supportedScriptsByNa;
    return ((_supportedScriptsByNa = supportedScriptsByNationality[personType]) == null ? void 0 : _supportedScriptsByNa.allSupportedScripts) || supportedScriptsByNationality.LEGAL.allSupportedScripts;
  }
  if (nameRegion === nationality) {
    var _supportedScriptsByNa2, _supportedScriptsByNa3, _supportedScriptsByNa4, _supportedScriptsByNa5;
    return ((_supportedScriptsByNa2 = supportedScriptsByNationality[personType]) == null ? void 0 : (_supportedScriptsByNa3 = _supportedScriptsByNa2.nationality) == null ? void 0 : _supportedScriptsByNa3[nationality]) || ((_supportedScriptsByNa4 = supportedScriptsByNationality[personType]) == null ? void 0 : _supportedScriptsByNa4.allSupportedScripts) || ((_supportedScriptsByNa5 = supportedScriptsByNationality.LEGAL.nationality) == null ? void 0 : _supportedScriptsByNa5[nationality]) || supportedScriptsByNationality.LEGAL.allSupportedScripts;
  }
  return ((_supportedScriptsByNa6 = supportedScriptsByNationality[personType]) == null ? void 0 : (_supportedScriptsByNa7 = _supportedScriptsByNa6.nationality) == null ? void 0 : _supportedScriptsByNa7[nationality]) || ((_supportedScriptsByNa8 = supportedScriptsByNationality[personType]) == null ? void 0 : (_supportedScriptsByNa9 = _supportedScriptsByNa8.nationality) == null ? void 0 : _supportedScriptsByNa9.INTERNATIONAL) || ((_supportedScriptsByNa0 = supportedScriptsByNationality[personType]) == null ? void 0 : _supportedScriptsByNa0.allSupportedScripts) || ((_supportedScriptsByNa1 = supportedScriptsByNationality.LEGAL.nationality) == null ? void 0 : _supportedScriptsByNa1.INTERNATIONAL) || supportedScriptsByNationality.LEGAL.allSupportedScripts;
}
function validateNationalityScript(scripts, nationality, supportedScripts, nonEmptyNamefields, personType, nameRegion) {
  var errors = [];
  var nationalityScripts = getNationalityScripts(supportedScripts, personType, nationality, nameRegion);
  var isNationalityValid = false;
  for (var index = 0; index < scripts.length; index++) {
    if (nationalityScripts.indexOf(scripts[index]) !== -1) {
      isNationalityValid = true;
      break;
    }
  }
  if (!isNationalityValid) {
    nonEmptyNamefields.forEach(function (field) {
      errors.push({
        code: NAME_ERROR_CODE.INVALID_NATIONALITY_SCRIPT,
        element: field
      });
    });
  }
  return errors;
}
function validateScript(name, personType, nonEmptyNamefields, personNameValidRegEx) {
  var nameConcat = properties.reduce(function (nameConcat, item) {
    return nameConcat + (name[item] || "");
  }, "");
  var validCharacterRangeForCountryRegex = personNameValidRegEx[personType] || personNameValidRegEx[PERSON_TYPES.LEGAL];
  if (validCharacterRangeForCountryRegex) {
    validCharacterRangeForCountryRegex = new RegExp("^(" + validCharacterRangeForCountryRegex + ")$");
    // Checking INVALID_SCRIPT
    if (!isCharacterRangeMatch(validCharacterRangeForCountryRegex, nameConcat)) {
      var errors = [];
      nonEmptyNamefields.forEach(function (field) {
        var codePoint = invalidCodePointFromString(name[field], validCharacterRangeForCountryRegex);
        if (codePoint !== undefined) {
          errors.push({
            code: NAME_ERROR_CODE.INVALID_SCRIPT,
            element: field,
            invalidCodePoint: codePoint
          });
        }
      });
      return errors;
    }
  }
  return [];
}
function validatePunctuation(name, nameField, scriptBasedRegexes, errorMap) {
  if (!Object.keys(scriptBasedRegexes.punctuation.pattern).includes(nameField) || !name[nameField]) {
    return errorMap;
  }
  return getPunctuationNameError(scriptBasedRegexes.punctuation.pattern[nameField], name[nameField], nameField, errorMap);
}
function getPunctuationNameError(punctuationRegex, value, element, errorMap) {
  if (punctuationRegex) {
    punctuationRegex = new RegExp("^(" + punctuationRegex + ")*?$", "i");
    if (punctuationRegex.test(value)) {
      errorMap.INVALID_ALL_PUNCTUATION = {
        code: NAME_ERROR_CODE.INVALID_ALL_PUNCTUATION,
        element: element
      };
    }
  }
  return errorMap;
}
function validateRepetition(name, nameField, repetitionRegexObj, errorMap) {
  if (!Object.keys(repetitionRegexObj.pattern).includes(nameField) || !name[nameField]) {
    return errorMap;
  }
  var repetitionRegex = repetitionRegexObj.pattern[nameField];
  if (repetitionRegex) {
    var repetitionResult;
    repetitionRegex = new RegExp("^" + repetitionRegex + "*?$", "i");
    if ((repetitionResult = repetitionRegex.exec(name[nameField])) !== null) {
      errorMap.INVALID_CHARACTER_REPETITION = {
        code: NAME_ERROR_CODE.INVALID_CHARACTER_REPETITION,
        element: nameField,
        repeatedCharacter: repetitionResult.find(function (_) {
          return ![undefined, null].includes(_) && _ !== repetitionResult[0];
        })
      };
    }
  }
  return errorMap;
}
function validateHonorifics(name, nameField, honorificsVariation, errorMap) {
  if (!Object.keys(honorificsVariation.pattern).includes(nameField) || !name[nameField]) {
    return errorMap;
  }
  var honorificsRegex = honorificsVariation.pattern[nameField].join("|");
  if (honorificsRegex) {
    honorificsRegex = new RegExp("^(" + honorificsRegex + ")$", "i");
    if (honorificsRegex.test(name[nameField])) {
      errorMap.INVALID_ALL_HONORIFICS = {
        code: NAME_ERROR_CODE.INVALID_ALL_HONORIFICS,
        element: nameField
      };
    }
  }
  return errorMap;
}
function validateBoundaryValidation(name, nameField, boundaryValidation, errorMap) {
  if (!Object.keys(boundaryValidation.pattern).includes(nameField) || !name[nameField]) {
    return errorMap;
  }
  var boundaryValidationRegex = boundaryValidation.pattern[nameField];
  if (boundaryValidationRegex) {
    // We don't add ^( and )$ because the regex already has position based tokens
    boundaryValidationRegex = new RegExp(boundaryValidationRegex, "i");
    if (boundaryValidationRegex.test(name[nameField])) {
      var bvResult = boundaryValidationRegex.exec(name[nameField]);
      errorMap.INVALID_BOUNDARY_PATTERN = {
        code: NAME_ERROR_CODE.INVALID_BOUNDARY_PATTERN,
        element: nameField,
        invalidSequence: bvResult[0]
      };
    }
  }
  return errorMap;
}
function validateKeyboardBanging(name, nameField, scriptBasedRegexes, errorMap) {
  if (!Object.keys(scriptBasedRegexes.keyboardBanging.pattern).includes(nameField) || !name[nameField]) {
    return errorMap;
  }
  var keyboardBangingRegex = scriptBasedRegexes.keyboardBanging.pattern[nameField];
  var kbResult;
  if (keyboardBangingRegex) {
    keyboardBangingRegex = new RegExp(".*?(" + keyboardBangingRegex + ").*?", "i");
    if (keyboardBangingRegex.test(name[nameField])) {
      kbResult = keyboardBangingRegex.exec(name[nameField]);
      errorMap.INVALID_KEYBOARD_BANGING = {
        code: NAME_ERROR_CODE.INVALID_KEYBOARD_BANGING,
        element: nameField,
        invalidSequence: kbResult[1]
      };
    }
  }
  return errorMap;
}
function validateSingleCharacter(name, nameField, singleCharacterValidation, errorMap) {
  if (!singleCharacterValidation.pattern || !Object.keys(singleCharacterValidation.pattern).includes(nameField) || !name[nameField]) {
    return errorMap;
  }
  var singleCharacterRegexPat = singleCharacterValidation.pattern[nameField].join("|");
  if (singleCharacterRegexPat) {
    var singleCharacterRegex = new RegExp("^(" + singleCharacterRegexPat + ")$", "i");
    if (singleCharacterRegex.test(name[nameField])) {
      errorMap.INVALID_SINGLE_CHARACTER = {
        code: NAME_ERROR_CODE.INVALID_SINGLE_CHARACTER,
        element: nameField
      };
    }
  }
  return errorMap;
}
function validateNonVowel(name, nameField, scriptBasedRegexes, nameValidations, errorMap) {
  if (!Object.keys(scriptBasedRegexes.nonVowel.pattern).includes(nameField) || !name[nameField]) {
    return errorMap;
  }
  var nonVowelRegex = scriptBasedRegexes.nonVowel.pattern[nameField];
  var singleCharacterRegex = nameValidations.singleCharacterRegex.join("|");
  var honorificsRegex = nameValidations.honorificsRegex.join("|");
  var boundaryRegex = nameValidations.boundaryRegex;
  var punctuationRegex = scriptBasedRegexes.punctuationRegex;
  if (singleCharacterRegex && nonVowelRegex && honorificsRegex && punctuationRegex && boundaryRegex) {
    singleCharacterRegex = new RegExp("^(" + singleCharacterRegex + ")$", "i");
    nonVowelRegex = new RegExp("^(" + nonVowelRegex + ")$", "i");
    honorificsRegex = new RegExp("^(" + honorificsRegex + ")$", "i");
    boundaryRegex = new RegExp(boundaryRegex, "i");
    punctuationRegex = new RegExp("^(" + punctuationRegex + ")*?$", "i");
    if (!singleCharacterRegex.test(name[nameField]) && !honorificsRegex.test(name[nameField]) && !boundaryRegex.test(name[nameField]) && !punctuationRegex.test(name[nameField]) && !isInitialName(name, nameField, scriptBasedRegexes) && nonVowelRegex.test(name[nameField])) {
      errorMap.INVALID_ALL_NON_VOWEL = {
        code: NAME_ERROR_CODE.INVALID_ALL_NON_VOWEL,
        element: nameField
      };
    }
  }
  return errorMap;
}
function nameFormatToParts(name, props) {
  return formatToParts(name, props);
}
var getMissingMetadataError = function getMissingMetadataError(path) {
  var message = "Missing WorldReady metadata, please refer to https://github.paypal.com/pages/Globalization-R/worldready-js/docs/about-load-worldready-data.html";
  if (path) {
    message += "\nPath: " + path;
  }
  return new Error(message);
};
function validateCldr(path, value, options) {
  if (options === void 0) {
    options = {
      skip: []
    };
  }
  var skipBoolean = options.skip.some(function (regex) {
    return regex.test(path);
  });
  if (skipBoolean) {
    return;
  }
  if (value === undefined) {
    throw getMissingMetadataError(path);
  }
}
var countryAliasMapping = {
  C2: "CN",
  UK: "GB"
};
function getResolvedRegion(region) {
  return countryAliasMapping[region] || region;
}
var ENVIRONMENT = {
  PRODUCTION: "production"
};
var validateConstructorArguments = function validateConstructorArguments(worldReady, options) {
  assertType(worldReady, "worldReady", ["object", "plain object"]);
  if (!isWorldReadyInstance(worldReady)) {
    var _Cldr$attributes = new Cldr("und-" + worldReady.region).attributes,
      language = _Cldr$attributes.language,
      region = _Cldr$attributes.region;
    throw new Error("DEPRECATED WARNING: NameFormat API has changed for consistency with other formatters, see our updated docs for more information.\nFix your code by using:\n" + ("new NameFormat(new WorldReady(\"" + language + "-" + region + "\"), " + JSON.stringify(Object.assign({
      nameRegion: region
    }, options || {})) + ")"));
  }
  assertType(options, "options", ["undefined", "plain object"]);
  assertType(options.nameRegion, "options.nameRegion", ["string"]);
  assertNationalityWithBusinessType(options.nationality, options.type);
  assertBusinessTypeWithPerson(options.businessType, options.type);
  assertregisteredBusinessTypeWithPerson(options.registeredBusinessType, options.type);
  assertType(options.nationality, "options.nationality", ["null", "undefined", "string"]);
  assertType(options.persontype, "options.personType", ["null", "undefined", "string"]);
  assertType(options.businessType, "options.businessType", ["null", "undefined", "string"]);
  assertType(options.registeredBusinessType, "options.businessType", ["null", "undefined", "string"]);
};

/**
 *
 * @param {*} nameProperties object in form of
 * {
 *   regionDefaultScript: "",
 *   validationMetadata: {},
 *   requiredProperties: [],
 *   layouts: {},
 *   regionalData: {},
 *   defaultData: {}
 * }
 * @returns true if nameProperties is valid.
 */
function isNamePropertiesValid(nameProperties) {
  // validate properties
  if (!nameProperties || !nameProperties.regionalData || !nameProperties.defaultData || !nameProperties.regionDefaultScript || !nameProperties.layouts || !nameProperties.requiredProperties || !nameProperties.formatData || !nameProperties.validationMetadata) {
    return false;
  }
  return true;
}

/**
 * Returns nameProperties object in form of
 * {
 *   regionDefaultScript: "",
 *   validationMetadata: {},
 *   requiredProperties: [],
 *   layouts: {},
 *   regionalData: {},
 *   defaultData: {}
 * }
 * by getting data from Cldr
 * @param {*} cldr - Cldr instance
 * @param {*} type - type of name, i.e. person or business name
 * @param {*} nameRegion - region option for NameFormatter
 * @param {*} style - style option for NameFormatter
 * @param {*} formatAs - formatAs option for NameFormatter
 * @returns nameProperties object
 */
function getNameProprties(cldr, type, nameRegion, style, formatAs) {
  return {
    regionDefaultScript: cldr.get([CLDR_SUPPLEMENTAL_PERSON_NAME_DATA_PATH, nameRegion, "primaryScript"]) || cldr.get([CLDR_SUPPLEMENTAL_PERSON_NAME_DATA_PATH, "DEFAULT", "primaryScript"]),
    validationMetadata: cldr.get([CLDR_SUPPLEMENTAL_PERSON_NAME_DATA_PATH, nameRegion, "validations"]) || cldr.get([CLDR_SUPPLEMENTAL_PERSON_NAME_DATA_PATH, "DEFAULT", "validations"]),
    formatData: formatAs.titleCase ? cldr.get(["supplemental/commonNameData/region/default/script/default/formatAs"]) : {},
    requiredProperties: type === NAME_TYPES.PERSON ? cldr.get([CLDR_SUPPLEMENTAL_PERSON_NAME_DATA_PATH, nameRegion, "requiredProperties"]) || cldr.get([CLDR_SUPPLEMENTAL_PERSON_NAME_DATA_PATH, "DEFAULT", "requiredProperties"]) : cldr.get(["supplemental/businessNameData/default/requiredProperties"]),
    layouts: type === NAME_TYPES.PERSON ? cldr.get([CLDR_SUPPLEMENTAL_PERSON_NAME_DATA_PATH, nameRegion, "layouts", style]) || cldr.get([CLDR_SUPPLEMENTAL_PERSON_NAME_DATA_PATH, "DEFAULT", "layouts", style]) : cldr.get(["supplemental/businessNameData/default/layouts"]),
    regionalData: cldr.get([CLDR_SUPPLEMENTAL_PERSON_NAME_DATA_PATH, nameRegion]),
    defaultData: cldr.get([CLDR_SUPPLEMENTAL_PERSON_NAME_DATA_PATH, "DEFAULT"]),
    isLayoutProperties: cldr.get([CLDR_SUPPLEMENTAL_PERSON_NAME_DATA_PATH, nameRegion, "isLayoutProperties"]) || cldr.get([CLDR_SUPPLEMENTAL_PERSON_NAME_DATA_PATH, "DEFAULT", "isLayoutProperties"]),
    personNameValidRegEx: cldr.get([CLDR_SUPPLEMENTAL_PERSON_NAME_DATA_PATH, nameRegion, "personNameValidRegEx"]) || cldr.get([CLDR_SUPPLEMENTAL_PERSON_NAME_DATA_PATH, "DEFAULT", "personNameValidRegEx"])
  };
}
var NameFormat = /*#__PURE__*/function () {
  function NameFormat(worldReady, options) {
    var _nameProperties$isLay,
      _requiredPropsArray$p,
      _requiredPropsArray$p2,
      _this = this;
    if (process.env.NODE_ENV !== ENVIRONMENT.PRODUCTION) {
      validateConstructorArguments(worldReady, options);
    }
    options = options || {};
    var cldr = worldReady.globalize.cldr;
    // used for determining layout for a given locale.
    var localeScript = cldr.attributes.script;
    var nameRegion = getResolvedRegion(options.nameRegion);
    var _options4 = options,
      _options4$style = _options4.style,
      style = _options4$style === void 0 ? NAME_STYLES.FULL : _options4$style,
      _options4$type = _options4.type,
      type = _options4$type === void 0 ? NAME_TYPES.PERSON : _options4$type,
      _options4$personType = _options4.personType,
      personType = _options4$personType === void 0 ? PERSON_TYPES.LEGAL : _options4$personType,
      nationality = _options4.nationality,
      businessType = _options4.businessType,
      registeredBusinessType = _options4.registeredBusinessType,
      _options4$formatAs = _options4.formatAs,
      formatAs = _options4$formatAs === void 0 ? DEFAULT_FORMATAS : _options4$formatAs;
    if (process.env.NODE_ENV !== ENVIRONMENT.PRODUCTION) {
      assertType(style, "options.style", ["string"]);
      assertRange(style, Object.values(NAME_STYLES), "Invalid value for options.style: {value}, needs to be one of {{available}}", {
        value: style,
        available: Object.values(NAME_STYLES)
      });
      assertRange(personType, Object.values(PERSON_TYPES), "Value {{value}} is out of range for options.personType parameter", {
        value: personType
      });
      assertType(type, "options.type", ["string"]);
      assertRange(type, Object.values(NAME_TYPES), "Invalid value for options.type: {value}, needs to be one of {{available}}", {
        value: type,
        available: Object.values(NAME_TYPES)
      });
      assertType(formatAs.titleCase, "formatAs.titleCase", ["boolean"]);
    }
    this.type = type;
    this.personType = personType;
    this.nationality = nationality;
    var nameProperties = getNameProprties(cldr, type, nameRegion, style, formatAs);
    if (!isNamePropertiesValid(nameProperties)) {
      validateCldr();
    }
    var regionDefaultScript = nameProperties.regionDefaultScript,
      layouts = nameProperties.layouts,
      requiredPropsArray = nameProperties.requiredProperties,
      nameFormatData = nameProperties.formatData,
      validationsMeta = nameProperties.validationMetadata,
      personNameValidRegEx = nameProperties.personNameValidRegEx;
    var isLayoutProperties = (_nameProperties$isLay = nameProperties.isLayoutProperties[style]) != null ? _nameProperties$isLay : {};

    // If no nationality based override, then fallback to `INTERNATIONAL`
    var requiredFields = Array.isArray(requiredPropsArray) ? requiredPropsArray : (requiredPropsArray == null ? void 0 : (_requiredPropsArray$p = requiredPropsArray[personType]) == null ? void 0 : _requiredPropsArray$p[nationality]) || (requiredPropsArray == null ? void 0 : (_requiredPropsArray$p2 = requiredPropsArray[personType]) == null ? void 0 : _requiredPropsArray$p2.INTERNATIONAL) || (requiredPropsArray == null ? void 0 : requiredPropsArray.LEGAL[nationality]) || (requiredPropsArray == null ? void 0 : requiredPropsArray.LEGAL.INTERNATIONAL);
    this._validate = function (name) {
      return type === NAME_TYPES.PERSON ? validateName(name, {
        requiredFields: requiredFields,
        validationsMeta: validationsMeta,
        nationality: nationality,
        personType: personType,
        nameRegion: nameRegion,
        personNameValidRegEx: personNameValidRegEx
      }) : validateBusinessName(name, {
        validationsMeta: validationsMeta,
        businessType: businessType,
        registeredBusinessType: registeredBusinessType
      });
    };
    var supportedScripts = Object.keys(layouts);
    this._formatToParts = function (name, _ref9) {
      var includeIsLayoutProperties = _ref9.includeIsLayoutProperties;
      return nameFormatToParts(name, {
        layouts: layouts,
        regionDefaultScript: regionDefaultScript,
        localeScript: localeScript,
        supportedScripts: supportedScripts,
        requiredFields: requiredFields,
        formatAs: formatAs,
        nameFormatData: nameFormatData,
        isLayoutProperties: isLayoutProperties,
        includeIsLayoutProperties: includeIsLayoutProperties,
        personType: personType
      });
    };
    /**
     * Wrapper for _formatToParts() to assert name and pass options object without adding extra params
     * to the main API functions
     * @param {String} name Name to format
     * @param {Object} options Object that includes optional parameters to modify the behavior of formatToPartsobject in form of
     * {
     *   includesLayoutProperties: false, // Boolean flag that will either include or omit isLayout properties
     * }
     */
    this._callFormatToParts = function (name, options) {
      if (process.env.NODE_ENV !== ENVIRONMENT.PRODUCTION) {
        assertName(name);
        if (_this.type === NAME_TYPES.PERSON) {
          assert(!name.businessName, 'You are trying to format a business name using `new NameFormat(worldReady, { type: "person" })`. Please, use `new NameFormat(worldReady, { type: "business" })` instead');
        }
        if (_this.type === NAME_TYPES.BUSINESS) {
          assert(!name.givenName, 'You are trying to format a person name using `new NameFormat(worldReady, { type: "business" })`. Please, use `new NameFormat(worldReady, { type: "person" })` instead');
        }
      }
      return _this._formatToParts(name, options);
    };
  }
  var _proto = NameFormat.prototype;
  _proto.format = function format(name) {
    return this._callFormatToParts(name, {
      includeIsLayoutProperties: true
    }).reduce(function (memo, _ref0) {
      var value = _ref0.value;
      return memo + value;
    }, "");
  }

  /**
   * Name API functionality that will return an array of objects that make up each element
   * of a name provided
   * @param {String} name Name to format
   * @returns {Array} Array of objects with each part of a given name and a template
   */;
  _proto.formatToParts = function formatToParts(name) {
    return this._callFormatToParts(name, {
      includeIsLayoutProperties: false
    });
  };
  _proto.validate = function validate(name) {
    return this._validate(name);
  };
  return NameFormat;
}();
/**
 * NameFormatClient contains name format browser/client
 * side code.
 */
var NameFormatClient = /*#__PURE__*/function (_NameFormat) {
  function NameFormatClient() {
    return _NameFormat.apply(this, arguments) || this;
  }
  _inheritsLoose(NameFormatClient, _NameFormat);
  return NameFormatClient;
}(NameFormat);
function transformName(name, options) {
  var transformedName = Object.assign({}, name); //clone object
  if (options.fromType === options.toType) {
    // No need to perform tranformation
    return transformedName;
  }
  if (options.fromType === "oneSurname") {
    if (transformedName.surname) {
      var surnames = transformedName.surname.trim().split(/\u0020{2}(.+)/g); //splitting by first occurrence of double space
      transformedName.surname = surnames[0] ? surnames[0].trim() : "";
      transformedName.secondSurname = surnames[1] ? replaceDoubleSpaces(surnames[1]) : "";
    } else if (transformedName.secondSurname) {
      //only secondSurname is present in one2two transform
      transformedName.surname = "";
      transformedName.secondSurname = replaceDoubleSpaces(transformedName.secondSurname);
    }
  } else if (options.fromType === "twoSurnames") {
    if (transformedName.surname) {
      transformedName.surname = replaceDoubleSpaces(transformedName.surname);
      if (transformedName.secondSurname) {
        transformedName.secondSurname = replaceDoubleSpaces(transformedName.secondSurname);
        transformedName.surname = transformedName.surname + "  " + transformedName.secondSurname.trim();
        delete transformedName.secondSurname;
      }
    } else if (transformedName.secondSurname) {
      //only secondSurname is present in two2one transform
      transformedName.surname = replaceDoubleSpaces(transformedName.secondSurname); //populate ouptput.surname with input.secondSurname
      delete transformedName.secondSurname;
    }
  }
  return transformedName;
}
function replaceDoubleSpaces(namePart) {
  return namePart.trim().replace(/\u0020{2,}/g, " ");
}

/**
 * This class transform names either from one to two surname or
 * from two to one surname.
 */
var NameConverter = /*#__PURE__*/function () {
  function NameConverter(options) {
    if (process.env.NODE_ENV !== ENVIRONMENT.PRODUCTION) {
      assertType(options, "options", ["plain object"]);
      assertType(options.fromType, "options.fromType", ["string"]);
      assertType(options.toType, "options.toType", ["string"]);
      var availableTypes = ["oneSurname", "twoSurnames"];
      assertRange(options.fromType, availableTypes, "Invalid options.fromType {{value}}, expected one of {{availableTypes}}.", {
        value: options.fromType,
        availableTypes: availableTypes
      });
      assertRange(options.toType, availableTypes, "Invalid options.toType {{value}}, expected one of {{availableTypes}}.", {
        value: options.toType,
        availableTypes: availableTypes
      });
    }
    this._transform = function (name) {
      return transformName(name, options);
    };
  }
  var _proto2 = NameConverter.prototype;
  _proto2.transform = function transform(name) {
    if (process.env.NODE_ENV !== ENVIRONMENT.PRODUCTION) {
      assertType(name, "name", ["plain object"]);
    }
    name = name || {};
    return this._transform(name);
  };
  return NameConverter;
}();

export { NameConverter, NameFormatClient as NameFormat };
